module.exports = __webpack_public_path__ + "static/media/antigua-and-barbuda.66067de7.svg";